module.exports = __webpack_public_path__ + "toBride1-we-g-g.51c523b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-g-g.jpg
// module id = m6I/
// module chunks = 0